import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import LoadingScreen from "@/components/feature/LoadingScreen";
import AIChatWidget from "@/components/feature/AIChatWidget";
import AppErrorBoundary from "@/components/base/AppErrorBoundary";
import MetaPixel from "@/components/feature/MetaPixel";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <LoadingScreen />
      <BrowserRouter basename={__BASE_PATH__}>
        <MetaPixel />
        <AppErrorBoundary>
          <AppRoutes />
        </AppErrorBoundary>
        <AIChatWidget />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
